import { useMemo, useRef } from 'react';
import type { LinesGridApi } from './LinesGrid';

/**
 * Управление таблицей строк снаружи (`gridApiRef` у `LinesGrid`): `gridApiRef` отдаём таблице, а
 * `api` — обработчикам окна. `api` стабилен и всегда определён (пока таблица не смонтирована, его
 * методы ничего не делают), поэтому его можно безопасно передавать функциям, которые вызываются
 * при рендере: прямое чтение `ref.current` там запрещено правилами React.
 */
export function useLinesGridApi(): { gridApiRef: React.MutableRefObject<LinesGridApi | null>; api: LinesGridApi } {
  const gridApiRef = useRef<LinesGridApi | null>(null);
  const api = useMemo<LinesGridApi>(
    () => ({
      focusCell: (row, col) => gridApiRef.current?.focusCell(row, col),
      focusedRow: () => gridApiRef.current?.focusedRow() ?? null,
      addRow: () => gridApiRef.current?.addRow(),
      removeFocusedRow: () => gridApiRef.current?.removeFocusedRow(),
    }),
    [],
  );
  return { gridApiRef, api };
}
